"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoldingFeeCycleStatus = void 0;
var HoldingFeeCycleStatus;
(function (HoldingFeeCycleStatus) {
    HoldingFeeCycleStatus["PAID"] = "Paid";
    HoldingFeeCycleStatus["WAIVED"] = "Waived";
})(HoldingFeeCycleStatus || (exports.HoldingFeeCycleStatus = HoldingFeeCycleStatus = {}));
//# sourceMappingURL=holding-fee-types.js.map